// extracted by mini-css-extract-plugin
export var mainContainer = "styles-module--main-container--6daHf";
export var adWrapper = "styles-module--ad-wrapper--FqBuG";
export var adContainer = "styles-module--ad-container--nCJzP";